import MapHelpers from '../../map.utils';
import MapLayer from '../map-layer.enum';
import MapLayerVisibility from '../map-layer-visibility.enum';

const SOURCE_ID = MapLayer.FOCUS_REGION_AREA;

/**
 * Initialises the Iran Conflict area GeoJSON source and layers (fill + border).
 * Both layers start hidden. The source data is populated at runtime by
 * useIranConflictMapEffects once the feature flag boundary is available.
 *
 * Guard: if the source already exists (e.g. map re-initialised after a
 * token refresh or privilege change) the function exits early to prevent
 * the "There is already a source with ID" Mapbox error.
 */
function addIranConflictAreaLayer() {
  // Guard addSource — Mapbox throws if you add a source with a duplicate ID.
  // This can happen when loadAllLayers re-runs after a token refresh or
  // privilege change: the source survives the re-init but the layers don't,
  // so we must skip addSource while still re-adding the layers below.
  const sourceAlreadyExists = !!MapHelpers.getSource(SOURCE_ID);

  if (!sourceAlreadyExists) {
    MapHelpers.addSource(SOURCE_ID, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [],
      },
    });
  }

  // Add layers individually so a partial-init (source present, layers absent)
  // is always recovered without duplicating existing layers.

  // Semi-transparent blue fill
  if (!MapHelpers.getLayer(MapLayer.FOCUS_REGION_AREA_FILL)) {
    MapHelpers.addLayer({
      id: MapLayer.FOCUS_REGION_AREA_FILL,
      type: 'fill',
      source: SOURCE_ID,
      layout: {
        visibility: MapLayerVisibility.NOT_VISIBLE,
      },
      paint: {
        'fill-color': '#1976d2',
        'fill-opacity': 0.08,
      },
    });
  }

  // Solid blue border
  if (!MapHelpers.getLayer(MapLayer.FOCUS_REGION_AREA)) {
    MapHelpers.addLayer({
      id: MapLayer.FOCUS_REGION_AREA,
      type: 'line',
      source: SOURCE_ID,
      layout: {
        visibility: MapLayerVisibility.NOT_VISIBLE,
      },
      paint: {
        'line-color': '#1976d2',
        'line-width': 2,
      },
    });
  }

  // On re-initialisation the source was already in use, meaning conflict mode
  // was previously active. Restore visibility immediately so the user doesn't
  // have to refresh the page to see the overlay.
  if (sourceAlreadyExists) {
    MapHelpers.setLayerVisibility(MapLayer.FOCUS_REGION_AREA, true);
    MapHelpers.setLayerVisibility(MapLayer.FOCUS_REGION_AREA_FILL, true);
  }
}

export default addIranConflictAreaLayer;
